import { IconLayoutDashboard, IconPackages } from '@tabler/icons-react'
import {
	Coins,
	Command,
	FileText,
	FolderOpen,
	GalleryVerticalEnd,
	Image,
	Wallet,
} from 'lucide-react'
import type { SidebarData } from '../types'

export const sidebarData: Omit<SidebarData, 'user'> = {
	teams: [
		{
			name: ' User',
			logo: Command,
			plan: '',
		},
		{
			name: 'Ente',
			logo: GalleryVerticalEnd,
			plan: '',
		},
	],
	navGroups: [
		{
			title: 'General',
			items: [
				{
					title: 'Dashboard',
					url: '/dashboard',
					icon: IconLayoutDashboard,
				},
				{
					title: 'Projects',
					url: '/projects',
					icon: IconPackages,
				},
				{
					title: 'Trade',
					url: '/trade',
					icon: Coins,
				},
			],
		},
		{
			title: 'Grower/Consultant',
			items: [
				{
					title: 'Drafts',
					url: '/grower/drafts',
					icon: FileText,
				},
				{
					title: 'My Projects',
					url: '/grower/my-projects',
					icon: FolderOpen,
				},
			],
		},
		{
			title: 'Investor',
			items: [
				{
					title: 'My Assets',
					url: '/investor/my-assets',
					icon: Wallet,
				},
				{
					title: 'NFTs',
					url: '/investor/nfts',
					icon: Image,
				},
			],
		},
		{
			title: 'Certification Entity',
			items: [
				{
					title: 'Project Requests',
					url: '/observer/certification-requests',
					icon: FileText,
				},
			],
		},
	],
}
